export default __webpack_public_path__ + "static/LiveWorkZoning-d9174eb6a3eb741f06fbc11a8662dd14.jpg";